// @flow
import styled from '@emotion/styled';

export const OrganizationPage = styled.div`
  background-color: ${props => props.theme.COLORS.GRAY_10};
`;
